const NRJavaIcon = ({ height = '24', width = '24' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none">
    <path
      d="M16.0282 14.6669C16.4877 14.3529 17.125 14.081 17.125 14.081C17.125 14.081 15.311 14.4092 13.5064 14.5592C11.2986 14.742 8.9268 14.7794 7.73619 14.6201C4.91899 14.2451 9.28299 13.2091 9.28299 13.2091C9.28299 13.2091 7.59083 13.0967 5.50491 14.0997C3.04406 15.2904 11.5986 15.8341 16.0282 14.6669Z"
      fill="#007396"
    />
    <path
      d="M12.0253 13.1623C11.1347 11.1608 8.13003 9.40298 12.0253 6.32805C16.8862 2.49377 14.3924 0 14.3924 0C15.4002 3.96091 10.8488 5.16091 9.2034 7.62181C8.08307 9.30458 9.75186 11.1093 12.0253 13.1623Z"
      fill="#ED8B00"
    />
    <path
      d="M17.397 4.90295C17.4017 4.90295 9.18461 6.95606 13.108 11.4747C14.2658 12.806 12.8033 14.006 12.8033 14.006C12.8033 14.006 15.7424 12.4873 14.3924 10.5888C13.1314 8.81695 12.1658 7.93573 17.397 4.90295Z"
      fill="#ED8B00"
    />
    <path
      d="M17.1113 17.5827C17.0879 17.6389 17.0176 17.6999 17.0176 17.7045C23.0315 16.1249 20.819 12.1311 17.9456 13.1437C17.6924 13.2327 17.5613 13.439 17.5613 13.439C17.5613 13.439 17.7206 13.3733 18.077 13.2983C19.53 12.9937 21.6159 15.2436 17.1113 17.5827Z"
      fill="#007396"
    />
    <path
      d="M19.3237 20.503C19.3237 20.503 20.0033 21.0608 18.5783 21.4967C15.8644 22.317 7.29104 22.5654 4.90982 21.5296C4.05202 21.1592 5.65977 20.6389 6.16607 20.5311C6.69099 20.4186 6.99569 20.4373 6.99569 20.4373C6.04413 19.767 0.841068 21.7545 4.35197 22.3218C13.9237 23.8779 21.8081 21.6233 19.3237 20.503Z"
      fill="#007396"
    />
    <path
      d="M8.84258 18.5623C5.15356 19.5935 11.0879 21.7217 15.7846 19.7107C15.016 19.4108 14.4628 19.0639 14.4628 19.0639C12.3675 19.4623 11.3973 19.4904 9.49414 19.2748C7.92385 19.0967 8.84258 18.5623 8.84258 18.5623Z"
      fill="#007396"
    />
    <path
      d="M17.2705 23.1184C13.5815 23.8121 9.03009 23.7326 6.33472 23.2871C6.33472 23.2825 6.88787 23.7418 9.72844 23.9247C14.0502 24.2013 20.6877 23.7699 20.8424 21.7263C20.8424 21.7263 20.5424 22.4997 17.2705 23.1184Z"
      fill="#007396"
    />
    <path
      d="M15.227 16.5467C12.452 17.0811 10.8443 17.067 8.81463 16.8561C7.24429 16.692 8.27087 15.9327 8.27087 15.9327C4.20223 17.2826 10.5302 18.8108 16.216 17.1467C15.6114 16.9357 15.227 16.5467 15.227 16.5467Z"
      fill="#007396"
    />
  </svg>
);

export default NRJavaIcon;
